<template>
  <SelectComponent
    :value="value"
    :filter="filter"
    :title="$t('selectOneOrMoreX', { x: $tc('product', 2).toLowerCase() })"
    class="product-select-modal"
    v-bind="{ ...$attrs, search: false }"
    v-on="$listeners"
    ref="selector"
    @input="$ev => $emit('input', $ev)"
    @select="$ev => $emit('select', $ev)"
  >
    <template #item="{ item, disabled, scope }">
      <div>
        <slot name="item" :item="item" :disabled="disabled" :scope="scope">
          <ProductCard theme="list" :value="item" :disabled="disabled">
            <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]>
              <slot :name="slot" :item="item" />
            </template>
          </ProductCard>
        </slot>
      </div>
    </template>
    <template #empty>
      <slot name="empty">
        <ProductCard theme="list" :value="{ name: labels.notset }" />
      </slot>
    </template>
    <template #noresults="{ filter }">
      <div class="text--center">{{ $t('couldnotfindonquery', { query: filter.search }) }}</div>
    </template>
    <template #bottom>
      <slot name="bottom" />
    </template>
    <template #header>
      <slot name="header" />
    </template>
    <template #sidebar>
      <slot name="sidebar-top" />
      <template v-if="showFilters">
        <div class="card__title product-select-modal__filter-label">{{ $t('filter') }}</div>
        <InputComponent :label="$t('search')" class="select-modal__search mb-2">
          <input class="elder-input__element" type="text" :placeholder="$t('search') + '...'" v-model="filter.search" />
          <div class="elder-input__icon">
            <FontAwesomeIcon :icon="['fal', 'search']" />
          </div>
        </InputComponent>
        <InputComponent :label="$tc('category', 1)" class="mb-2">
          <template #default>
            <VirtualCategory :items="$ev => get('categories', $ev)" mode="select-only" v-model="filter.category" />
          </template>
          <template #below>
            <a
              v-if="filter.category"
              href="#"
              @click.prevent="filter.category = null"
              style="font-size: 0.8em; text-decoration: none; margin-top: 5px"
            >
              <FontAwesomeIcon :icon="['fal', 'times']" style="margin-right: 3px" />
              <span>{{ $t('resetSelection') }}</span>
            </a>
          </template>
        </InputComponent>

        <div class="product-select-modal__tags-filter">
          <Tags
            :label="$tc('tag', 2)"
            v-model="filter.tags"
            :placeholder="$t('select') + '...'"
            :autocomplete="$ev => get('tags', $ev)"
            add-only-from-autocomplete
            :autocomplete-min-length="0"
          >
          </Tags>
          <a
            v-if="filter.tags.length"
            href="#"
            @click.prevent="filter.tags = []"
            style="font-size: 0.8em; text-decoration: none; margin-top: 5px"
          >
            <FontAwesomeIcon :icon="['fal', 'times']" style="margin-right: 3px" />
            <span>{{ $t('resetSelection') }}</span>
          </a>
        </div>
      </template>
    </template>
    <template #actions>
      <slot name="actions" />
    </template>
  </SelectComponent>
</template>

<script>
import ProductCard from '@/components/Product/Card'
import SelectComponent from '@/components/Select/Modal'
import { InputComponent } from 'vue-elder-input'
import Tags from '@/components/Tags'
import VirtualCategory from '@/components/VirtualCategory'
import { mapi18n } from '@/i18n'

export default {
  props: {
    value: [Object, Array],
    subtitle: String,
    host: String,
    showFilters: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      filter: {
        search: null,
        tags: [],
        category: null,
      },
    }
  },
  computed: {
    ...mapi18n('labels', ['notset']),
  },
  methods: {
    get(type, search) {
      let qs = search ? `?search=${search}` : ''
      return fetch(`${this.host || ''}/api/product/${type}${qs}`).then(res => res.json())
    },
    open() {
      this.$refs.selector.open()
    },
  },
  components: {
    ProductCard,
    SelectComponent,
    InputComponent,
    Tags,
    VirtualCategory,
  },
}
</script>

<style lang="scss">
.product-select-modal {
  .card {
    width: 100%;
    max-width: 1200px;
  }

  .card__title {
    border-bottom: 1px solid var(--border-color);
    padding-bottom: 1rem;
    margin-bottom: 1rem;
  }

  .elder-input {
    &__label {
      color: css-alpha('dark', 0.75);
      font-weight: normal;
      font-size: 0.85em;
    }
  }

  &__tags-filter {
    .ti-autocomplete {
      max-height: 300px;
      overflow-y: auto;

      @include scrollShadow();
    }
  }

  .category-input {
    flex-direction: column;
  }

  .select-modal__modal-sidebar {
    width: 100%;
    max-width: 350px;
  }

  &__add-product {
    text-align: center;
    color: css-alpha('dark', 0.5);
    font-size: 0.8em;
    padding: 1rem;

    a {
      display: block;
      margin-top: 5px;
    }
  }
}
</style>
